<template>
    <router-view />
</template>

<script>
import { addOnRpcErrorListener } from '@platform/components/rpc';
import { useLoginEnabledApp } from '@platform/layouts/login/hooks';
import routes from '@managing/router/routes';
import { isAxiosError } from 'axios';
import { sockApi } from '@platform/shared/rpc/socket/sock-api.js';

export default {
    name: 'App',
    setup() {
        useLoginEnabledApp(routes);
        sockApi._.useSocketConnectionState('default');
    },
    mounted() {
        addOnRpcErrorListener(this.onRpcErrorHandler);
    },
    methods: {
        onRpcErrorHandler(type, error) {
            if (error && isAxiosError(error) && error.config?.url?.endsWith('pusk/login')) {
                return;
            }
            this.$q.notify({
                message:
                    type === 'NetworkError'
                        ? 'Отсутствует соединение с сервером. Проверьте ваше подключение к Интернету и попробуйте повторить операцию'
                        : 'Произошла ошибка на сервере\n' +
                          String(error?.response?.data?.message || '').substring(0, 80),
                position: 'top-right',
                icon: 'report_problem',
                color: 'negative',
                timeout: 5000,
                multiLine: true,
                actions: [
                    {
                        label: 'ОК',
                        color: 'white',
                    },
                ],
            });
        },
    },
};
</script>

<style lang="scss"></style>
